import * as React from "react";

export type SelectProps = {
    autoComplete?: string,
    autoFocus?: boolean,
    className?: string,
    defaultValue?: string[],
    disabled?: boolean,
    id?: string,
    maxLength?: number,
    name?: string,
    placeholder?: string,
    readOnly?: boolean,
    type?: string,
    value?: string | number | string[]
}

export type SelectActions = {
    onBlur?(event: React.FocusEvent<HTMLSelectElement>): void,
    onChange?(event: React.ChangeEvent<HTMLSelectElement>): void,
    onFocus?(event: React.FocusEvent<HTMLSelectElement>): void,
    onSelect?(event: React.SyntheticEvent<HTMLSelectElement>): void
}

export type SelectPropsAndActions = SelectProps & SelectActions;

class Text extends React.PureComponent<SelectPropsAndActions, any> {
    render() {
        return (
            <select
                autoComplete={this.props.autoComplete}
                autoFocus={this.props.autoFocus}
                className={this.props.className}
                defaultValue={this.props.defaultValue}
                disabled={this.props.disabled}
                id={this.props.id}
                name={this.props.name}
                value={this.props.value}
                onBlur={this.props.onBlur}
                onChange={this.props.onChange}
                onFocus={this.props.onFocus}
                onSelect={this.props.onSelect}
            >
                {this.props.children}
            </select>
        );
    }
}

export default Text;
